"use client";

import * as React from "react";
import { Button } from "../primitives/button";
import { cn } from "../primitives/cn";

export type EmptyStateVariant = "first-use" | "no-results" | "filtered";

/**
 * EmptyState — always include a next-step CTA.
 */
export function EmptyState({
  title,
  description,
  actionLabel,
  onAction,
  variant = "first-use",
  className,
}: {
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  variant?: EmptyStateVariant;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-3 rounded-lg border border-dashed border-border px-6 py-12 text-center",
        className,
      )}
      data-variant={variant}
    >
      <h3 className="text-base font-medium">{title}</h3>
      {description ? (
        <p className="max-w-sm text-sm text-muted-foreground">{description}</p>
      ) : null}
      {actionLabel && onAction ? (
        <Button type="button" onClick={onAction} className="mt-2">
          {actionLabel}
        </Button>
      ) : null}
    </div>
  );
}
